module.exports = __webpack_public_path__ + "img/power_strip_pairing_mode.6bde1b26.png";